module.exports = __webpack_public_path__ + "dfcab558c460a301e711e2075f1cd81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/P@2x.png
// module id = 831
// module chunks = 0